import { Component, Input, ChangeDetectorRef } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { TablerIconComponent } from "angular-tabler-icons";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { ApiService } from "../../../../../../../../shared/src/lib/services/api.service";
import { environment } from "../../../../../../../../shared/src/lib/environments/environment";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-horizontal-nav-item",
    imports: [TablerIconComponent, CommonModule, MatIconModule, RouterModule, MatButton],
    templateUrl: "./nav-item.component.html",
    styleUrl: "nav-item.component.scss"
})
export class AppHorizontalNavItemComponent {
  @Input() depth: any;
  @Input() item: any;
  private betTickerWindow: Window | null = null;
  private pspAdminWindow: Window | null = null;
  constructor(
    public readonly router: Router,
    private readonly apiService: ApiService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }


  onItemSelected(item: any) {
    if (item && item?.displayName === "Bet Ticker") {
      this.onBetTickerSelected(item);
    } else if (item && item?.displayName === "Bet Ticker V1") {
      this.onBetTickerV1Selected(item);
    } else if (item && item?.displayName === "PSP Admin") {
      this.onPspAdminSelected();
    } else if (item && item?.displayName === "KJsport9 Admin") {
      this.onKjsport9Selected(item);
    } else if (!item?.children?.length) {
      this.router.navigate([item?.route]);
    }
  }

  onKjsport9Selected(item: any) {
    let url = "";
    url = environment.kjsport9URL;
    if (!this.betTickerWindow || this.betTickerWindow.closed) {
      this.betTickerWindow = window.open(url, "kjsport9Tab");
    } else {
      this.betTickerWindow.location.href = url;
      this.betTickerWindow.focus();
    }
    this.cdr.detectChanges();
  }

  onBetTickerV1Selected(item: any) {
    let url = "";
    let oUserData = this.apiService.getUserToken();
    if (oUserData == null) {
      return;
    }
    const accessToken = oUserData.access_token;
    url = environment.betTickerV1URL + "." + this.apiService.getDomainName() + `?token=${accessToken}`;
    if (!this.betTickerWindow || this.betTickerWindow.closed) {
      this.betTickerWindow = window.open(url, "betTickerTab");
    } else {
      this.betTickerWindow.location.href = url;
      this.betTickerWindow.focus();
    }
    this.cdr.detectChanges();
  }
  onBetTickerSelected(item: any) {
    let url = "";
    let oUserData = this.apiService.getUserToken();
    if (oUserData == null) {
      return;
    }
    const accessToken = oUserData.access_token;
    url = environment.betTickerURL + "." + this.apiService.getDomainName() + `?token=${accessToken}`;
    if (!this.betTickerWindow || this.betTickerWindow.closed) {
      this.betTickerWindow = window.open(url, "betTickerTab");
    } else {
      this.betTickerWindow.location.href = url;
      this.betTickerWindow.focus();
    }
    this.cdr.detectChanges();
  }

  onPspAdminSelected() {
    let oUserData = this.apiService.getUserToken();
    if (!oUserData?.access_token) {
      return;
    }

    const url = new URL(environment.pspAdminURL);
    url.searchParams.set("token", oUserData.access_token);

    if (!this.pspAdminWindow || this.pspAdminWindow.closed) {
      this.pspAdminWindow = window.open(url.toString(), "pspAdminTab");
    } else {
      this.pspAdminWindow.location.href = url.toString();
      this.pspAdminWindow.focus();
    }
    this.cdr.detectChanges();
  }

  openInNewTab(event: MouseEvent, item: any) {
    event.preventDefault();
    const url = this.router.serializeUrl(this.router.createUrlTree([item.route]));
    window.open(url, "_blank");
  }
}
